import logo from '../../assets/images/logo/iA_cloud_w.svg';
import { FaLinkedin, FaMedium } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t }: { t: (key: string) => string } = useTranslation();

  return (
    <footer className="bg-gray-900 text-white py-10">
      <div className="max-w-4xl mx-auto text-center">
        <div className="mb-3 flex justify-center">
          <img src={logo} alt="iA Cloud Logo" className="w-[107px]" />
        </div>

        <div className="text-sm text-white space-y-1">
          <p className="text-base font-bold">{t('Footer.company')}</p>
          <p>
            {t('Footer.ceo')} | {t('Footer.businessNumber')}
          </p>
          <p>{t('Footer.address')}</p>
          <p>
            {t('Footer.email')}:{' '}
            <a href="mailto:consult@iacloud.kr" className="hover:text-primary transition">
              {t('Footer.emailAddress')}
            </a>
          </p>
        </div>

        <div className="mt-6">
          <p className="text-sm text-gray-500">{t('Footer.copyright')}</p>

          <div className="flex justify-center space-x-6 mt-4">
            <a
              href="https://www.linkedin.com/company/%EC%95%84%EC%9D%B4%EC%97%90%EC%9D%B4%ED%81%B4%EB%9D%BC%EC%9A%B0%EB%93%9C/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-primary transition"
              title="LinkedIn"
            >
              <FaLinkedin size={24} />
            </a>

            <a
              href="https://medium.com/@iacloud_blog"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 rounded-lg hover:text-primary transition"
              title="Medium"
            >
              <FaMedium size={24} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
